import React from 'react';

const SearchCounter = ({ count, label = "resultados", className = "", isSearching = false }) => {
  // Handle zero case
  if (count === 0) {
    const message = isSearching 
      ? `No se encontraron ${label}` 
      : `No hay ${label} registrados`;
    
    return (
      <div className={`text-sm text-gray-500 mt-2 px-1 ${className}`}>
        {message}
      </div>
    );
  }

  // Format number with Spanish locale (adds commas for thousands)
  const formattedCount = count.toLocaleString('es-ES');
  
  // Handle singular/plural Spanish grammar
  const isPlural = count !== 1;
  
  // Different messaging for searching vs showing total
  let message;
  if (isSearching) {
    const verb = isPlural ? "encontrados" : "encontrado";
    message = `${formattedCount} ${label} ${verb}`;
  } else {
    const totalLabel = isPlural ? `${label} registrados` : `${label} registrado`;
    message = `${formattedCount} ${totalLabel}`;
  }
  
  return (
    <div className={`text-sm text-gray-500 mt-2 px-1 ${className}`}>
      {message}
    </div>
  );
};

export default SearchCounter;